import {
  CustomTextField,
  DecimalTextField,
  DrawerFormSection,
  InfoTooltip,
} from '../../common/components';
import { drawerFieldSpan as span } from '../../common/styles';
import { TRANSITION_TEXTS } from '../constants/materialValuationTexts';

/**
 * Fuente explícita en ARS para ingresos sin costo previo, como sección con el formato de Finanzas.
 * @param {Object} props
 * @param {Object} [props.value] Precio, notas y evidencia cargados.
 * @param {Function} props.onChange Recibe el objeto actualizado.
 * @param {string} [props.title] Título de la sección (por ejemplo, con el material).
 * @param {boolean} [props.disabled] Deshabilita los campos.
 * @returns {JSX.Element}
 */
const MaterialTransitionFields = ({
  value = {},
  onChange,
  title = TRANSITION_TEXTS.title,
  disabled,
}) => {
  const handleChange = (event) => onChange({ ...value, [event.target.name]: event.target.value });

  return (
    <DrawerFormSection
      title={title}
      action={<InfoTooltip lines={[TRANSITION_TEXTS.info]} />}
      sx={{ mx: 0 }}
    >
      <DecimalTextField
        label={TRANSITION_TEXTS.price}
        name="unit_cost_ars"
        decimals={2}
        value={value.unit_cost_ars || ''}
        onChange={handleChange}
        disabled={disabled}
        sx={span(4)}
      />
      <CustomTextField
        label={TRANSITION_TEXTS.notes}
        name="notes"
        value={value.notes || ''}
        onChange={handleChange}
        disabled={disabled}
        sx={span(8)}
      />
      <CustomTextField
        label={TRANSITION_TEXTS.evidence}
        name="evidence"
        value={value.evidence || ''}
        onChange={handleChange}
        disabled={disabled}
        sx={span(12)}
      />
    </DrawerFormSection>
  );
};

export default MaterialTransitionFields;
